

export class RouteGroupStatusInput implements IRouteGroupStatusInput {
    /** The auto-generated id of the route group master */
    routeGroupId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IRouteGroupStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeGroupId = _data["routeGroupId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RouteGroupStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGroupStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeGroupId"] = this.routeGroupId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IRouteGroupStatusInput {
    /** The auto-generated id of the route group master */
    routeGroupId: number;
    /** The updated status */
    status: number;
}

